

<template>
  <br>
  <p class="fw-bold">   </p>

  <div class="d-flex  mb-2 w-100 justify-content-evenly">
    <div style="width: 6vw;" class="  d-flex flex-column">
      <label class="text-end required">کد  </label>
      <input v-model="code" type="text" class="form-control">
    </div>
    <div style="width: 10vw;" class="  d-flex flex-column">
      <label class="text-end required">عنوان ستانده</label>
      <textarea v-model="title" class="form-control" cols="20" rows="30"></textarea>

    </div>

    <div style="width: 10vw;" class="  d-flex flex-column">
      <label class="text-end ">
        <span class="required">فرآیند مربوطه</span>
      <span title="در این بخش فرآیندهایی که در بخش شناسنامه مشخصات کلی و شاخص  آن  تکمیل شده است نمایش داده می شوند">❔</span>
      </label>
      <input type="text" class="form-control" readonly placeholder="انتخاب کنید" @click.prevent="showListInserter" v-model="inserterName">
    </div>

    <div style="width: 10vw;" class="  d-flex flex-column">
      <label class="text-end required">پست سازمانی  </label>
      <input type="text" class="form-control" readonly  v-model="organizationpostName">

    </div>
    <div style="width: 10vw;" class="  d-flex flex-column">
      <label class="text-end required">شاخص اندازه گیری     </label>
      <select @change="selectUnit" v-model="unit_id" name="" class="form-select" id="">
        <option value="" selected disabled>انتخاب کنید</option>
        <option v-for="item in all_itemsUnit" :value="item.id">{{item.description}}</option>
      </select>

    </div>
    <div class="  d-flex flex-column">
      <label class="text-end required">  واحد سنجش شاخص        </label>
      <input v-model="unit_name" type="text" class="form-control" readonly  >

    </div>
    <button v-if="!is_update" @click.prevent="submitForm" style="margin-top: 1.3vw;" class="btn btn-primary btn-submit-1">ثبت</button>
    <button v-else @click.prevent="update(id)" style="margin-top: 1.3vw;" class="btn btn-primary btn-submit-1">ویرایش</button>
  </div>

  <center>
    <hr style="width: 70vw; margin: 1vw 0;">

    <p v-show="!items.length">
      ستانده وجود ندارد
    </p>
    <div style="overflow-y: scroll; height: 50vw;" :style="allItems.length < 19 ? 'height: auto;' : ''">

    <table v-show="items.length" class="table table-striped" style="width: 70vw;" >
      <thead>
      <tr>
        <th>ردیف  </th>
        <th>کد  </th>
        <th>عنوان  </th>
        <th>فرآیند  </th>
        <th>پست سازمانی  </th>
        <th>شاخص اندازه گیری    </th>
        <th>واحد سنجش شاخص    </th>
        <th style="width: 8vw;">عملیات</th>
      </tr>
      </thead>
      <tbody>
      <tr  v-for="(item,index) in items">
        <td scope="row" style="  font-size: 1vw">{{index+1}}</td>
        <td >{{item.code}}</td>
        <td >{{item.title}}</td>
        <td>{{item.process.title}}</td>
        <td>{{item.process.general_profile.organizationpost.name}}</td>
        <td>{{item.monitoring?.description}}</td>
        <td>{{item.monitoring?.unit }}</td>
        <td>
          <a @click.prevent="edit(item.id)" href="#"><img class="table-edit-img" src="/img/pen.6428fd02.svg" alt="edit"></a>
          <a @click.prevent="deleteItemModal(item.id)" href="#"><img class="table-delete-img mx-2"  src="/img/delete.f9fc94bc.svg" alt="delete"></a>
        </td>
      </tr>

      </tbody>
    </table>
    </div>
  </center>
  <div dir="rtl" class="modal__error slide-top" v-show="select_inserter"
       style="z-index: 999999999999999999999999999999999999999999999; top: 25%;">
    <div>
      <p>تامین کننده ورودی</p>
      <p @click="select_inserter=!select_inserter">❌</p>
    </div>
    <div>
      <input v-model="search_inserter" class="form-control mb-3" type="text"
             placeholder="جستجو بر اساس کد و عنوان...">
             <div style=" height: 14vw; overflow: auto; ">
      <table class="table table-striped">
        <thead>
        <tr>
          <th style="width: 1vw;">انتخاب</th>
          <th>کد</th>
          <th>عنوان</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in filteredorganization" :key="item.id">
          <td scope="row"><input v-model="inserterId" type="radio" name="parent" :value="item['id']"></td>
          <td>{{ item['code'] }}</td>
          <td>{{ item['name'] }}</td>
        </tr>

        </tbody>
      </table>
      </div>
      <button @click="select_inserterMethod">تایید</button>
    </div>
  </div>
  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="deleteModal" style="z-index: 999999999999999; top: 40%;">
    <div>
      <p>حذف</p>
      <p @click="deleteModal=!deleteModal">❌</p>
    </div>
    <div>
      <p>آیا میخواهید حذف کنید!</p>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="deleteModal=!deleteModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="deleteItemForm(id)">تایید</button>
      </div>
    </div>
  </div>
  <!-- modal  -->

</template>
<script  >
export  default {
  data(){
    return{
      deleteModal: false,
      select_inserter: false,
      search_inserter: '',
      inserterId: '',
      inserterName: '',
      items: [],
      all_inserter: [],
      all_itemsUnit: [],
      organizationpostName: '',
      unit_id: '',
      unit_name: '',
      code: '',
      title: '',
      id: '',
      is_update: false
    }
  },
  methods:{

    deleteItemModal(id){
      this.id=id
      this.deleteModal=true

    },
    edit(id){
      var myHeaders = new Headers();

      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();

      formdata.append('code', this.code)
      formdata.append('title', this.title)
      formdata.append('process_id', this.inserterId)
      formdata.append('monitoring_process_id', this.unit_id)
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/definition_of_output/show/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response){
              this.code=response.item.code
              this.title=response.item.title
              this.inserterId=response.item.process.id
              this.inserterName=response.item.process.title
              this.showUnits(response.item.process.id)
              this.unit_id=response.item.monitoring.id
              this.unit_name=response.item.monitoring.unit
              this.organizationpostName = response.item.process.general_profile.organizationpost.name
              this.is_update=true
              this.id = response.item.id
            }



          })
          .catch();
    },
    update(id){
      var myHeaders = new Headers();

      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();

      formdata.append('code', this.code)
      formdata.append('title', this.title)
      formdata.append('process_id', this.inserterId)
      formdata.append('monitoring_process_id', this.unit_id)
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/definition_of_output/update/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response){
              this.code=''
              this.title=''
              this.inserterId=''
              this.unit_id=''
              this.unit_name=''
              this.organizationpostName=''
              this.inserterName=''
              this.all_itemsUnit.length=0
              this.allItems()
              this.is_update=false
              this.id=''
            }



          })
          .catch();
    },
    deleteItemForm(id){
      var myHeaders = new Headers();

      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();

      formdata.append('code', this.code)
      formdata.append('title', this.title)
      formdata.append('process_id', this.inserterId)
      formdata.append('monitoring_process_id', this.unit_id)
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/definition_of_output/delete/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response){

              this.deleteModal=false
              this.id=''
              this.allItems()
            }



          })
          .catch();
    },
    submitForm(){
      var myHeaders = new Headers();

      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();

      formdata.append('code', this.code)
      formdata.append('title', this.title)
      formdata.append('process_id', this.inserterId)
      formdata.append('monitoring_process_id', this.unit_id)
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/definition_of_output/store`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response){
              this.code=''
              this.title=''
              this.inserterId=''
              this.unit_id=''
              this.unit_name=''
              this.organizationpostName=''
              this.inserterName=''
              this.all_itemsUnit.length=0
              this.allItems()
            }



          })
          .catch();
    },
    allItems(){
      var myHeaders = new Headers();

      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();

      formdata.append('code', this.code)
      formdata.append('title', this.title)
      formdata.append('process_id', this.inserterId)
      formdata.append('monitoring_process_id', this.unit_id)
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/definition_of_output/all`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.items){
              this.items.length=0
              response.items.forEach((item)=>{
                this.items.push(item)
              })
            }



          })
          .catch();
    },
    showListInserter() {
      this.inserterName=''
      this.unit_name=''
      this.all_itemsUnit.length=0
      this.organizationpostName=''
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/processes/all_by_chain`, requestOptions)
          .then(response => response.json())
          .then(result => {
            this.all_inserter.length = 0

            if (result['items'].length !== 0) {
              result['items'].forEach(item => {
                this.all_inserter.push(item)
                this.select_inserter = true

              })

            }

          })
          .catch();
    },
    select_inserterMethod() {

      this.all_inserter.forEach((ele) => {
        ele.id === this.inserterId ? this.inserterName = ele.name : ''
      })
      this.select_inserter = false
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/general_profile/show/${this.inserterId}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.item){
              this.organizationpostName= response.item.organizationpost.name
              this.showUnits(this.inserterId)

            }



          })
          .catch();


    },
    showUnits(id) {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/monitoring_process/all/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.all) {
              this.all_itemsUnit.length = 0
              response.all.forEach((item) => {
                this.all_itemsUnit.push(item)
              })

            }


          })
          .catch();

    },
    selectUnit(){
      this.all_itemsUnit.forEach((ele)=>{
        ele.id === this.unit_id ? this.unit_name = ele.unit:''
      })
    },
  },
  computed:{
    filteredorganization() {
      return this.all_inserter.filter(item => {
        return (
            item['title'].includes(this.search_inserter) ||
            item['code'].toString().includes(this.search_inserter)
        );
      });
    },
  },
  mounted() {
    this.allItems()
  }
}

</script>
<style scoped>
label{
  font-size: .8vw;
}
</style>